import type { LinkData } from './models';

// 注意: 認証外にも公開されるため、機密情報は直接記載しないこと
export const linkData: LinkData = {
  groups: [
    {
      name: 'データ・可視化',
      links: [
        {
          label: 'Lightdash: 学習項目から問題とテストを探す',
          url: 'https://lightdash.classi-dataplatform.com/projects/0ca8013a-7c62-4116-83ed-fb10377d0df5/dashboards/d942c852-3332-4f64-8fe7-7ea937ca108c/view',
        },
        {
          label: 'Lightdash: 教科書一覧',
          url: 'https://lightdash.classi-dataplatform.com/projects/0ca8013a-7c62-4116-83ed-fb10377d0df5/dashboards/e0425f6e-176d-41d6-b475-341afc886667/view',
        },
        {
          label: 'Lightdash: 学トレ搭載動画一覧',
          url: 'https://lightdash.classi-dataplatform.com/projects/0ca8013a-7c62-4116-83ed-fb10377d0df5/dashboards/e2f15395-34da-4e29-bdb9-a9749f52e669/view/tabs/afb4f9d7-cf4e-4a99-a079-edb2732ab112',
        },
        {
          label: 'Lightdash: 単元反映状況比較',
          url: 'https://lightdash.classi-dataplatform.com/projects/0ca8013a-7c62-4116-83ed-fb10377d0df5/dashboards/cd25ef71-6388-4d4e-96ae-108d4983663d/view/tabs/43a5f31c-e87d-4c76-8eb1-26d2629083d6',
        },
      ],
    },
    {
      name: 'マニュアル・ドキュメント',
      links: [
        {
          label: 'toibox操作マニュアル',
          url: 'https://classi.atlassian.net/wiki/spaces/prodkobito/pages/3390571202/toibox',
        },
        {
          label: '学トレコンテンツ情報項目',
          url: 'https://docs.google.com/spreadsheets/d/1cgK6bvuIjTuiG4k0zT3jPZymCU05IraXNTguSYAJogY/edit?gid=1253129491#gid=1253129491',
        },
        {
          label: '動画属性仕様',
          url: 'https://docs.google.com/spreadsheets/d/1ywewgCr6OLIUOeFngGLJt1cWHLmlQP5dR1wlZwYero4/edit?gid=218846237#gid=218846237',
        },
      ],
    },
  ],
};
